import { apiClient } from '../../app/lib/api-client';
import { authClient } from '../../app/lib/auth-client';
import { AuthService } from './auth.api';
import { APIContainer } from './container';
import { TranslationService } from './translation.api';
import { UserLanguageService } from './user-language.api';
import { UserService } from './user.api';

let apiContainer: APIContainer | undefined;
let authContainer: APIContainer | undefined;

const initContainer = () => {
    if (!apiContainer) {
        apiContainer = new APIContainer(apiClient);
        apiContainer.register('user', UserService);
        apiContainer.register('translation', TranslationService);
        apiContainer.register('userLanguage', UserLanguageService);
    }

    if (!authContainer) {
        authContainer = new APIContainer(authClient);
        authContainer.register('auth', AuthService);
    }

    return {
        user: apiContainer.get<UserService>('user'),
        translation: apiContainer.get<TranslationService>('translation'),
        auth: authContainer.get<AuthService>('auth'),
        userLanguage: apiContainer.get<UserLanguageService>('userLanguage'),
    };
};

export default initContainer();
